// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bjKz8bbNW7sYY8Zr8V_N{width:100%}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Schedule/ui/SchedulePeriod/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA","sourcesContent":[".wrap {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `bjKz8bbNW7sYY8Zr8V_N`
};
export default ___CSS_LOADER_EXPORT___;
